export default __webpack_public_path__ + "assets/aed90018a7901e77db9969f7d9db7d5f.png";